import './Text.css'


export function Text(){
    return(
        <div className='title-partner'>
            <h2 className='h2-partners'>INTO THE METAVERSE</h2>
            <h1 className="h1-partners">Want to transform your brand from 2D to 3D?</h1>
            <p className='p-partners'>Our global community of Immersive language learners crave authentic
            cultural experiences while in VR. Together, we can turn that dream into a reality by co-creating a metaverse brand experience
            that our users love and your stakeholders celebrate.</p>
        </div>
    )
}